import { createVar } from '~/theme';

export const imgUrl = createVar('slabIcon-imgUrl');
export const size = createVar('slabIcon-size');
